
import React from "react";
import { Accordion, AccordionPanel, Panel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { Popover } from "@ronuse/norseu/core/overlay";
import { DialogPage } from "./DialogPage";
import { Scheme } from "@ronuse/norseu/core/variables";

export class PopoverPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
        this.button1 = React.createRef();
        this.emailRef = React.createRef();
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    buildDocumentation() {
        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="norseu-display-flex">
                                <Button text="Show Basic" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={(e) => this.popover1 && this.popover1.toggle(e)} />
                                <Popover ref={(el) => this.popover1 = el}>
                                    <div style={{ backgroundColor: "white", width: "200px", padding: "10px", borderRadius: 6 }}>
                                        {DialogPage.basicText()} 
                                    </div>
                                </Popover>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Dismisable</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p">
                                Prevent dismissing the pop over when clicked out side the popover. The popover can be toggled by 
                                only clicking the toggle button.
                            </p>
                            <div className="norseu-display-flex">
                                <Button text="Show Popover" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={(e) => this.popover2 && this.popover2.toggle(e)} />
                                <Popover ref={(el) => this.popover2 = el} dismissable={false}>
                                    <div style={{ backgroundColor: "white", width: "200px", padding: "20px" }}>
                                        {DialogPage.basicText()} 
                                    </div>
                                </Popover>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Focus and Trapping</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p">
                                <h3>Focus an element when popover show or hide</h3>
                                Set the element that recieve focus when the popover is shown using the <code>onOpenFocusRef</code>, 
                                also an element can receive when the popover is out of the DOm by passing the <code>onCloseFocusRef</code> prop.
                            </p>
                            <div className="norseu-display-flex">
                                <Button text="Show Popover" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={(e) => this.popover3 && this.popover3.toggle(e)} />
                                <Button ref={this.button1} text="Receive focus on popover close"/>
                                <Popover ref={(el) => this.popover3 = el} onOpenFocusRef={this.emailRef} onCloseFocusRef={this.button1}>
                                    <div style={{ backgroundColor: "white", padding: "20px" }}>
                                        {DialogPage.formControls(this.emailRef, (e) => this.popover3 && this.popover3.toggle(e))} 
                                    </div>
                                </Popover>
                            </div>
                            <p className="documentation-p">
                                <h3>Trapping focus in Popover</h3>
                                Focus can also be trapped within the pop over and close the popover when the user click the button on the form. 
                                Specify the <code>trapFocus</code> and <code>onOpenFocusRef</code> prop to trap a focus, if focus is trapped in the 
                                popover the dialog is non dismissable, excpt using the toggle.
                            </p>
                            <div className="norseu-display-flex">
                                <Button text="Show Popover" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={(e) => this.popover4 && this.popover4.toggle(e)} />
                                <Popover ref={(el) => this.popover4 = el} onOpenFocusRef={this.emailRef} trapFocus>
                                    <div style={{ backgroundColor: "white", padding: "20px" }}>
                                        {DialogPage.formControls(this.emailRef, (e) => this.popover4 && this.popover4.toggle(e))} 
                                    </div>
                                </Popover>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "Popover",
            import_statement: "import { Popover } from '@ronuse/norseu/core/overlay'",
            properties: this.properties,
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/overlay/PopoverPage.js"
        });
    }

    state = {
        pageSource: '',
        showSourceDialog: false
    };

    cssMap = [

    ];

    properties = [
        { name: "dismissable", type: "boolean", default: true, description: "If true clicking event outside the popver will hide the popover" },
        { name: "className", type: "string", default: null, description: "CSS classes to apply to the popover compound element" },
        { name: "style", type: "object", default: null, description: "CSS Style to apply to the popover compound element" },
        { name: "pointingArrowClassName", type: "string", default: null, description: "The popover pointer arrow class name, leave as null to use the default pointer" },
        { name: "transitionOptions", type: "object", default: "", description: "React transition group option for the popover" },
        { name: "onOpenFocusRef", type: "React.Ref", default: null, description: "The component ref that receive focus once the popover is visible in DOM" },
        { name: "onCloseFocusRef", type: "React.Ref", default: null, description: "The component ref that receive focus once the popover is removed from DOM" },
        { name: "baseZIndex", type: "number", default: 1001, description: "The base z-index of the popover" },
        { name: "container", type: "element", default: "document.body", description: "The parent element to render the popover in" },
        { name: "trapFocus", type: "boolean", default: false, description: "Trap the document focus in the popover by refocusing the onOpenFocusRef when outside the popover is clicked" },
        { name: "matchTargetSize", type: "boolean", default: false, description: "If true the popover width will match the width of the target component" },
        { name: "onShow", type: "function", default: "(event)", description: "The callback that is invoked when the popover is visible in DOM" },
        { name: "onHide", type: "function", default: "(event)", description: "The callback that is invoked when the popover is removed from the DOM" },
    ];
    
    refMap = [
        { name: "toggle()", type: "function", description: "Toggle the popover visibility, show and hide" },
        { name: "rePosition(target)", type: "function", description: "Reposition the popover location to match the target location" },
        { name: "value()", type: "function", description: "Returns the value of the component internal HTML element" },
        { name: "setValue(value)", type: "function", description: "Set the value of the component internal HTML element" },
        { name: "focus()", type: "function", description: "Send focus to the component" },
        { name: "getInternalElement()", type: "function", description: "Get the react reference to the internal element" },
        { name: "getState()", type: "function", description: "Get the current state of the component" },
        { name: "setState(newState)", type: "function", description: "Change the component state" },
    ]

}
